import React from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useSelector } from 'react-redux';
import { selectPageModelSE0 } from 'store/pageModel';

export const MetaOpenGraphProduct = () => {
	const pageModelSEO = useSelector(selectPageModelSE0);

	const title = pageModelSEO?.pageTitle || '';
	const description = pageModelSEO?.metadescription || '';
	const canonical = pageModelSEO?.canonicalURL || '';

	return (
		<Helmet>
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:type" content="website" />
			<meta
				property="og:image"
				content="https://leroymerlin.ru/etc/designs/elbrus/images/logo.svg"
			/>
			<meta property="og:url" content={canonical} />
		</Helmet>
	);
};
